import { Grid, MenuItem, TextField, makeStyles } from "@material-ui/core";
import MuiTextField from "@material-ui/core/TextField";
import { SketchPicker } from "react-color";
import { LineType, LineTypeObj } from "../../../utils/chartOptions";

const style = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
}));

export const ChartCustom = ({ makeLine, setMakeLine, line }) => {
  const classes = style();

  const handleTypeFieldChange = (event) => {
    setMakeLine((prev) => {
      if (event.target?.name !== undefined) {
        return {
          ...prev,
          [event.target.name]: event.target.value,
        };
      } else {
        return {
          ...prev,
          stroke: event.hex,
        };
      }
    });
  };

  const dataKeyValid = (dataKey) => {
    if (line.length !== 0) {
      for (let el of line) {
        if (dataKey === el.dataKey) return true;
      }
    }
    return false;
  };

  return (
    <div className={classes.root}> 
      <Grid container spacing={3} alignContent="center">
        <Grid item xs={6}>
          <TextField
            name={"type"}
            onChange={handleTypeFieldChange}
            variant={"outlined"}
            size={"small"}
            helperText={"Выберите тип линии"}
            select
            fullWidth
            required
            value={makeLine.type}
          >
            {LineType.map((el) => (
              <MenuItem key={`line-type-${el}`} value={el}>
                {LineTypeObj[el]}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={6}>
          <MuiTextField
            value={makeLine.dataKey}
            onChange={handleTypeFieldChange}
            name={"dataKey"}
            fullWidth
            type="text"
            variant={"outlined"}
            size={"small"}
            helperText={
              !dataKeyValid(makeLine.dataKey)
                ? "Название"
                : "Введите уникальное значение"
            }
            error={dataKeyValid(makeLine.dataKey)}
          />
        </Grid>
        <Grid item xs={12}>
          <SketchPicker
            name={"stroke"}
            color={makeLine.stroke}
            onChange={handleTypeFieldChange}
          />
        </Grid>
      </Grid>
    </div>
  );
};
